'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Tools = require('./Tools');

var _Tools2 = _interopRequireDefault(_Tools);

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KendoEditorTool = {
    name: 'kendo-editor-tool',
    render: function render() {
        return _vue2.default.prototype._e;
    },

    mixins: [_Tools2.default]
};

exports.default = KendoEditorTool;